import { useEffect } from 'react';

import { identifyUser } from '../lib/utils/posthog';

export default function usePostHogIdentify(user) {
  useEffect(() => {
    if (user) identifyUser(user);
  }, [user]);
}
